var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Tooltip"},[_vm._v(" "+_vm._s(_vm.tooltip)+" "),_c('span',{staticClass:"Tooltip__arrow"})])}
var staticRenderFns = []

export { render, staticRenderFns }